// one trust, axeptio, didomi

export function initCMPShopifyBridge() {
	// console.log(
	// 	'%c🧩 CMP ↔ Shopify Bridge - Initialisation',
	// 	'color:#6b5bff;font-weight:700;',
	// );

	/* =========================================================
	 * 1️⃣  UTILITAIRES GÉNÉRAUX
	 * ========================================================= */
	const Utils = {
		waitFor(cond, {interval = 100, timeout = 8000} = {}) {
			return new Promise((resolve, reject) => {
				const start = Date.now();
				(function loop() {
					if (cond()) return resolve(true);
					if (Date.now() - start > timeout) return reject(new Error('timeout'));
					setTimeout(loop, interval);
				})();
			});
		},
		log(title, color = '#888', data) {
			if (data !== undefined) {
				console.group(`%c${title}`, `color:${color};font-weight:600;`);
				console.log(data);
				console.groupEnd();
			} else {
				console.log(`%c${title}`, `color:${color};font-weight:600;`);
			}
		},
	};

	/* =========================================================
	 * 2️⃣  SHOPIFY CONSENT MANAGER
	 * ========================================================= */
	const ShopifyConsent = {
		api: null,

		async init() {
			await Utils.waitFor(
				() => window.Shopify?.customerPrivacy?.setTrackingConsent,
			);
			this.api = window.Shopify.customerPrivacy;
		},

		updateFromCMP(cmpName, values) {
			if (!this.api) return console.warn('⚠️ Shopify API non disponible');

			this.api.setTrackingConsent(values, () => {
				Utils.log(
					`[Shopify] Consent mis à jour depuis ${cmpName}`,
					'#4a9eff',
					values,
				);

				// Log du consentement réel stocké dans Shopify

				Utils.log(
					'[Shopify] currentVisitorConsent',
					'#2ecc71',
					window.Shopify.trackingConsent.currentVisitorConsent(),
				);
			});
		},
	};

	/* =========================================================
	 * 3️⃣  CMP ADAPTERS
	 * ========================================================= */

	// --- Didomi ---
	const DidomiAdapter = {
		name: 'Didomi',
		detect: () => !!window.Didomi,

		getValues() {
			try {
				const status = window.Didomi?.getCurrentUserStatus?.();
				if (!status?.purposes) {
					return {analytics: false, marketing: false, preferences: false};
				}

				const purposes = status.purposes;

				// --- Mappage logique des catégories ---
				const analyticsKeys = [
					'measure_ad_performance',
					'measure_content_performance',
					'market_research',
					'improve_products',
				];

				const marketingKeys = [
					'select_basic_ads',
					'select_personalized_ads',
					'create_ads_profile',
					'create_content_profile',
					'select_personalized_content',
					'retargetin-KUQ4TzVz',
				];

				const preferencesKeys = [
					'cookies',
					'functional-UkTcy3QN',
					'device_characteristics',
					'geolocation_data',
					'fidelisati-bzznWwDb',
				];

				const analytics = analyticsKeys.some(
					(key) => purposes[key]?.enabled === true,
				);
				const marketing = marketingKeys.some(
					(key) => purposes[key]?.enabled === true,
				);
				const preferences = preferencesKeys.some(
					(key) => purposes[key]?.enabled === true,
				);

				return {analytics, marketing, preferences};
			} catch (e) {
				console.warn('Erreur récupération consent Didomi:', e);
				return {analytics: false, marketing: false, preferences: false};
			}
		},

		attach(onChange) {
			let done = false;
			const sync = (d) => {
				if (done) return;
				done = true;
				onChange(this.getValues());
				d?.on?.('consent.changed', () => onChange(this.getValues()));
			};
			window.didomiOnReady = window.didomiOnReady || [];
			window.didomiOnReady.push((Didomi) => sync(Didomi || window.Didomi));
			if (window.Didomi?.getCurrentUserStatus) sync(window.Didomi);
		},
	};

	/* =========================================================
	 * 4️⃣  GESTIONNAIRE CMP
	 * ========================================================= */
	const CMPManager = {
		adapters: [DidomiAdapter],
		active: null,

		async detect() {
			const maxAttempts = 10;
			const delayMs = 3000;
			for (let attempt = 1; attempt <= maxAttempts; attempt++) {
				for (const a of this.adapters) {
					if (a.detect()) {
						this.active = a;
						Utils.log(`✅ CMP détecté : ${a.name}`, '#8b5cff');
						return a;
					}
				}
				if (attempt < maxAttempts) {
					Utils.log(
						`⏳ Aucun CMP détecté (tentative ${attempt}/${maxAttempts}). Nouvel essai dans 3s…`,
						'#ff9800',
					);
					await new Promise((r) => setTimeout(r, delayMs));
				}
			}

			// Dernière tentative après le chargement complet du DOM
			if (document.readyState === 'loading') {
				await new Promise((resolve) => {
					document.addEventListener('DOMContentLoaded', resolve, {once: true});
				});
			}
			for (const a of this.adapters) {
				if (a.detect()) {
					this.active = a;
					Utils.log(
						`✅ CMP détecté (après DOMContentLoaded) : ${a.name}`,
						'#8b5cff',
					);
					return a;
				}
			}

			console.warn('⚠️ Aucun CMP détecté');
			return null;
		},

		async start() {
			const cmp = await this.detect();
			if (!cmp) return;

			cmp.attach((values) => {
				ShopifyConsent.updateFromCMP(cmp.name, values);
			});
		},
	};

	/* =========================================================
	 * 5️⃣  INITIALISATION
	 * ========================================================= */
	(async function init() {
		window.Shopify.loadFeatures(
			[{name: 'consent-tracking-api', version: '0.1'}],
			(err) => {
				if (err) console.error(err);
			},
		);
		try {
			await ShopifyConsent.init();
			await CMPManager.start();
		} catch (err) {
			console.error("❌ Erreur d'initialisation CMP ↔ Shopify", err);
		}
	})();
}
